<template>
  <div class="mt-4">
    <span style="color: #17A2B8; font-weight: 500"> {{nombre}} </span>
    <b-row class="mt-3">
      <b-col cols="5">
        <b-card>
          <div style="margin-top: -20px;">
          <span class="fontsPeque" style="font-weight: 600">Opciones configuradas</span>
          </div>

            <div style="max-height: 400px;  height: 200px; overflow-y: scroll">
              <div v-for="color in colores" :key="color" >
                <span>{{color}}</span>
              </div>
            </div>
        </b-card>
      </b-col>
      <b-col cols="7">
        <div class="mt-2">
          <span class="fontsPeque">Tipo de flujo físico <span style="color: red"> *</span> </span>
          <v-select
              class="fontsPeque"
              id="idTipoFlujoFisico"
              label="nombre"
              v-model="guardar.flujo"
              :options="listaTipoFlujoFisico"
              required
              placeholder="Selecciona el tipo de flujo"
              multiple
          />
        </div>
        <div class="mt-4 ">
          <b-form-checkbox v-model="guardar.opcionOtro">
            <span style="font-size: 10px"> ¿Cuenta con opción "Otro"? </span>
          </b-form-checkbox>
        </div>
        <div class="mt-4">
          <b-form-checkbox v-model="guardar.configuraTercios">
            <span style="font-size: 10px"> ¿Se configuran tercios? </span>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>

    <div class="text-center mt-4">
      <b-button variant="outline-primary" pill size="sm" class="m-2" @click="guardarColorimetros" :disabled="this.guardar.flujo.length === 0">
        <span>Guardar</span>
      </b-button>
      <b-button variant="outline-secondary" pill size="sm" @click="cerrarModal()">
        <span>Cancelar</span>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalColorimetro",
  components: {},
  props:{
    listaTipoFlujoFisico: Array,
    objColorimetro: Object,
    editar: Boolean,
  },
  data: () => ({
    nombre: null,
    guardar: {
      idColorimetro: null,
      flujo: [],
      opcionOtro: false,
      configuraTercios: false,
    },
    colores: [],
  }),
  created() {
    if (this.editar){
      this.nombre = this.objColorimetro.nombre;
      this.guardar.idColorimetro = this.objColorimetro.idColorimetro;
      this.guardar.flujo =  this.objColorimetro.flujo
      this.guardar.opcionOtro =  this.objColorimetro.opcionOtro
      this.guardar.configuraTercios =  this.objColorimetro.configuraTercios
      this.colores = this.objColorimetro.colores;
    }
  },
  methods: {
    guardarColorimetros(){

      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.$http.post(this.$api + "labs/guardar/colorimetros", this.guardar)
              .then((resp) => {
                if (resp.data.data) {
                  this.$swal({
                    icon: "success",
                    text: "Se guardó correctamente la información ",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {
                      console.log("emit ..")
                      this.$emit('obtenerColorimetros');
                    }
                  })

                }
              })
        }
      })
    },
    cerrarModal(){
      this.$emit('cerrarModal');
    }
  }
}
</script>
<style scoped>
.fontsPeque {
  font-size: 11px;
}
</style>